/**
 * Landing page components for the Boty creator app.
 *
 * These components display value proposition, feature highlights,
 * and FAQ help chat for first-time visitors.
 *
 * Story 6.1: Marketing Landing Page with A/B Variants
 * - VariantA: Conversation First - Chat preview prominent
 * - VariantB: Mobile-First Vertical - Single column scroll
 * - VariantC: Split Screen Desktop - 50/50 with tabbed examples
 *
 * Story 6.7: Landing Page Header And Footer For Credibility
 * - LandingHeader: Minimal header with logo, sign in, language switcher
 * - LandingFooter: Professional multi-column footer
 */

export { FeatureHighlights } from './FeatureHighlights';
export { WelcomeSection } from './WelcomeSection';
export { UseCasesSection } from './UseCasesSection';
export { HelpChat } from './HelpChat';
export { LandingLayout } from './LandingLayout';
export { VideoHero } from './VideoHero';
export { matchFaq } from './faqResponses';

// Header and Footer (Story 6.7)
export { LandingHeader } from './LandingHeader';
export { LandingFooter } from './LandingFooter';

// A/B Test Variants (Story 6.1)
export { VariantA, VariantB, VariantC } from './variants';

// Shared variant components
export {
  BotInspirationFeed,
  ConversationPreview,
  HowItWorks,
  SocialProof,
  StickyCTA,
} from './shared';

export type {
  FeatureVariant,
  FeatureHighlightsProps,
  WelcomeSectionProps,
  HelpChatMessage,
  LandingLayoutProps,
  FaqEntry,
  FaqResponses,
  LandingHeaderProps,
} from './types';
